import { useTeamTree } from '@internal/backstage-plugin-common-library-react';
import {
  getKPIItems,
  getScorecardItems,
  OperationalExcellenceTable,
  toStandardISO,
  useGetCategoriesData,
} from '@internal/backstage-plugin-scorecard-common-react';
import { DateTime } from 'luxon';
import React, { useMemo } from 'react';

import { LinkButton } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

import { Box } from '@material-ui/core';

const excludeList = new Set(['Velocity', 'Repository Ownership']);

export const TeamOperationalExcellence = () => {
  const { entity } = useEntity();

  const { teamTree } = useTeamTree(entity.metadata.name);
  const endDate = useMemo(() => toStandardISO(DateTime.now()), []);
  const startDate = useMemo(
    () => toStandardISO(DateTime.now().minus({ months: 5 }).startOf('month')),
    [],
  );

  const { value: categoriesData } = useGetCategoriesData(
    teamTree?.tree,
    startDate,
    endDate,
    'month',
  );

  const scorecardItems = useMemo(
    () => (categoriesData ? getScorecardItems(categoriesData) : null),
    [categoriesData],
  );

  const kpiItems = useMemo(
    () => (categoriesData ? getKPIItems(categoriesData) : null),
    [categoriesData],
  );

  const filteredKpiItems = useMemo(
    () => (kpiItems ?? []).filter(sItem => !excludeList.has(sItem.label)),
    [kpiItems],
  );

  const actions = (
    <Box display="flex">
      <LinkButton
        variant="outlined"
        color="primary"
        to="../engineering-insights"
      >
        View Engineering Insights
      </LinkButton>
    </Box>
  );

  return (
    <>
      {scorecardItems?.length && (
        <OperationalExcellenceTable
          scorecardItems={filteredKpiItems}
          rootEntity={entity.metadata.name}
          startDate={startDate}
          endDate={endDate}
          orgWide={false}
          monthsToShow={6}
          actions={actions}
          enableLinks
          ownerConfirmed
        />
      )}
    </>
  );
};
